interface DocumentError {
  id?: number;
  rawMessage?: string;
  errorCode?: string;
  description?: string;
  possibleSolutions?: string;
}

export const newDocumentError = (): DocumentError => {
  return {};
};

export default DocumentError;
